import { isNull } from 'lodash/fp';

import getIsServer from './get-is-server';

// Due to Firefox / Chrome following different standards. https://miketaylr.com/posts/2014/11/document-body-scrollTop.html
export function getScrollPosition() {
  return document.documentElement.scrollTop || (document.body.parentNode as any).scrollTop || document.body.scrollTop;
}

export function scrollTo(to = 0) {
  const isServer = getIsServer();
  if (isServer) {
    return;
  }

  window.scrollTo({
    behavior: 'smooth',
    top: to,
  });

  // this is used for `back to top` button after being clicked, return tab order to where it has id `backToTopPoint`
  const backToTopPoint = document.getElementById('backToTopPoint');
  if (backToTopPoint) {
    backToTopPoint.focus({ preventScroll: true });
  }
}

export function scrollToElement(element: HTMLElement | null, offset: number = 0) {
  if (isNull(element)) {
    return;
  }
  const scrollPosition = element.getBoundingClientRect().top + getScrollPosition() + offset;

  scrollTo(scrollPosition);
}
